<template>
	<div class="case-viewers">
		
		<InputGroup
			title="Set Case Viewers"
			desc="Select other users who can view this case. Use the search box to filter users by name."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			<MultiSelect
				:options="enrichedViewers"
				v-model="caseForm.viewers"
				:showAsTags="['case_relation']"
				/>      
		</InputGroup>


		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			:condensed="true"
			:oneColumn="true"
			:fixedToBottom="true"
			>
			<Button
				label="Save"
				color="green"
				size="large"
				icon="save" 
				@click="submitCaseViewers"
				/>
		</InputGroup>


	</div>
</template>

<script>

import InputGroup from "@/Components/InputGroup"
import Button from "@/Components/Button"
import MultiSelect from "@/Components/MultiSelect"

export default {
	props: [
		'thisCase',
		'viewers'
	],
	components: {
		InputGroup,
		Button,
		MultiSelect
	},
	data: () => {
		return {
			caseForm: {
				viewers: []
			},
		}
	},
	mounted(){
		this.caseForm.viewers = this.thisCase.viewers.map(viewer => viewer.id) // load in existing values
	},
	methods: {
		submitCaseViewers(){
			this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/viewers`, this.caseForm)  
		},
	},
	computed: {
		enrichedViewers(){
			return (this.viewers || []).map(viewer => {
				let case_relation = false

				const isEditor = Array.isArray(this.thisCase.editors) && this.thisCase.editors.find(e => e && e.id === viewer.id)
				if(isEditor){
					case_relation = 'Supporting Surgeon'
				}
				const isOwner = this.thisCase.user_id && this.thisCase.user_id === viewer.id
				if(isOwner){
					case_relation = 'Primary Surgeon'
				}
				const isManager = this.thisCase.manager && this.thisCase.manager.id === viewer.id
				if(isManager){
					case_relation = 'Rep'
				}
				return {
					...viewer,
					case_relation,
					disabled: case_relation ? true : false
				}
			})
		}
	}
}

</script>

<style scoped lang="sass">

.case-viewers
	select[multiple]
		width: 100%
		min-height: 200px



</style>